import React from 'react';
import MatchPairsQuestionReport from './MatchPairsQuestionReport';
import DummyQuestionReport from './DummyQuestionReport';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElements} from '../../../../incase-domain/elements/question';
import {IElementTextInput} from '../../../../incase-domain/elements/textInput';
import WordCloud from './WordCloud';
import {ISlide} from '../../../../incase-domain/slide';
import {Font} from '../../../../incase-domain/presentationTheme';
import QuestionLayout from '../common/QuestionLayout';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import DummyLikertScaleReport from './DummyLikertScaleReport';
import {IElementQuestionMatchPair} from '../../../../incase-domain/elements/question/questionMatchPair';
import {IElementSequenceQuestion} from '../../../../incase-domain/elements/question/questionSequence';
import DummySequenceQuestionReport from './DummySequenceQuestionReport';
import QuestionReportRespondents from './QuestionReportRespondents';

const DUMMY_RESPONDENTS_COUNT = 200;

const DUMMY_WORD_CLOUD = [
    {text: 'idea', count: 8},
    {text: 'team', count: 5},
    {text: 'feedback', count: 4},
    {text: 'clarity', count: 3},
    {text: 'fun', count: 2},
    {text: 'speed', count: 1},
];

interface IRenderQuestionReportProps {
    question: IQuestionElements | IElementTextInput | undefined;
    slide: ISlide | undefined;
    fontFamily?: Font;
    device?: DeviceType;
    palette?: string;
}

function RenderQuestionReport({device, fontFamily, question, slide, palette}: IRenderQuestionReportProps): JSX.Element {
    if (question?.type === ELEMENT.TEXT_INPUT) {
        return <WordCloud words={DUMMY_WORD_CLOUD} palette={palette} />;
    }

    if (!question) {
        return <></>;
    }

    const reportQuestion = question;

    const renderReport = (): JSX.Element => {
        switch (reportQuestion.type) {
            case ELEMENT.MATCH_PAIR_QUESTION:
                return <MatchPairsQuestionReport question={reportQuestion as IElementQuestionMatchPair} device={device} />;
            case ELEMENT.LIKERT_SCALE:
                return <DummyLikertScaleReport question={reportQuestion} />;
            case ELEMENT.SEQUENCE_QUESTION:
                return <DummySequenceQuestionReport question={reportQuestion as IElementSequenceQuestion} />;
            default:
                return <DummyQuestionReport question={reportQuestion} slide={slide} />;
        }
    };

    return (
        <QuestionLayout
            element={reportQuestion}
            device={device}
            hideCounter
            headerAddon={<QuestionReportRespondents count={DUMMY_RESPONDENTS_COUNT} />}
        >
            <div
                style={{
                    fontFamily: fontFamily?.name,
                    fontSize: `${reportQuestion.fontSize || 'initial'}em`,
                }}
                className={`c-questionReport ${device === DeviceType.MOBILE ? 'c-questionReport--mobile' : ''}`}
            >
                {renderReport()}
            </div>
        </QuestionLayout>
    );
}

export default RenderQuestionReport;
